import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Internal imports
import SectionGrid from '~/app/Components/Dashboard/OverviewV2/primitives/SectionGrid.jsx';

import XlinkAPI from '~/app/api/xlinkAPI';
import { actions } from '~/app/redux/overview/duck';
import { SUBMITTED_RETURN_STATUS_KEYS } from '../dashboardConstants';

const HeroRow = () => {
  const dispatch = useDispatch();
  const currentView = useSelector(
    state => state.drilldown.drilldownHistory[state.drilldown.drilldownHistory.length - 1],
  );

  useEffect(() => {
    let active = true;
    const fetchHeroCards = async () => {
      dispatch(actions.fetchHeroCards());

      try {
        const resp = await XlinkAPI.getHeroCardData();

        if (!resp.data) {
          throw new Error('Dashboard metrics unavailable');
        }
        if (active) {
          dispatch(actions.fetchHeroCardsSuccess(resp.data));
        }
      } catch (error) {
        if (active) {
          dispatch(actions.fetchHeroCardsFailure?.(error));
        }
      }
    };

    fetchHeroCards();
    return () => {
      active = false;
    };
  }, [dispatch, currentView?.loginID, currentView?.preparerID, currentView?.dd_token]);
  const heroCardsState = useSelector(state => state.dashboardOverview.heroCards);
  const heroCards = heroCardsState.data;

  const federalSubmitted = SUBMITTED_RETURN_STATUS_KEYS.reduce(
    (sum, key) => sum + (heroCards?.returnsSubmitted1040?.[key] || 0),
    0,
  );

  const businessSubmitted = SUBMITTED_RETURN_STATUS_KEYS.reduce(
    (sum, key) => sum + (heroCards?.returnsSubmittedCorp?.[key] || 0),
    0,
  );

  const overviewCards = [
    {
      key: 1,
      count: (heroCards?.total1040 || 0) + (heroCards?.totalBusiness || 0),
      title: 'Total Tax Returns',
      variant: 'totalTax',
      action: { type: 'returns' },
      sublabel: `${heroCards?.total1040 || 0} Federal / ${heroCards?.totalBusiness || 0} Business`,
      loading: heroCardsState?.loading,
      error: heroCardsState?.error,
    },
    {
      key: 2,
      count: federalSubmitted + businessSubmitted,
      title: 'Submitted Returns',
      variant: 'submittedReturns',
      sublabel: `${federalSubmitted} Federal / ${businessSubmitted} Business`,
      loading: heroCardsState?.loading,
      error: heroCardsState?.error,
    },
    {
      key: 3,
      count: heroCards?.bankProductCount || 0,
      title: 'Bank Applications',
      variant: 'bankApps',
      sublabel: '',
      loading: heroCardsState?.loading,
      error: heroCardsState?.error,
    },
  ];

  return <SectionGrid cards={overviewCards} title="Overview"></SectionGrid>;
};

export default HeroRow;
